export default "__VITE_ASSET__5ad6267f__"